module.exports = __webpack_public_path__ + "static/media/loading.5d79bf49.gif";